import styled from 'styled-components';

export const TitleContainer = styled.div`
`;

export const TitleWrapper = styled.div`
    text-align: center;
`;

export const SubTitleWrapper = styled.div`
    text-align: center;
    margin-bottom: 24px;
`;

export const BtnServiceContainer = styled.div`
`;

export const BtnServiceWrapper = styled.div`
    padding: 8px 20px 8px 20px;

    &:first-child {
        padding: 16px 20px 8px 20px;
    }
`;

export const CaptionWrapper = styled.div`
    padding: 0 20px;
`;